import React, { type SelectHTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import type IFormInputs from "./IFormInputs";
import { PleaseSelect } from "./PleaseSelect";
import { useGetTimezoneName } from "src/shared/contacts/timezones/useGetTimezoneName";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import { required as Required } from "src/shared/forms/validations/Required";
import type { Timezone } from "src/shared/objects/Timezone";

export interface ITimezoneInputProps
  extends IFormInputs,
    SelectHTMLAttributes<HTMLSelectElement> {
  timezones: Timezone[];
}

export default (props: ITimezoneInputProps) => {
  const {
    timezones,
    inputID,
    label = <FormattedMessage id="contacts.timezone" />,
    ...rest
  } = props;
  const getTimezoneName = useGetTimezoneName();
  return (
    <Field
      name={inputID}
      label={label}
      type="select"
      component={InputRenderer}
      validate={[Required]}
      {...rest}
    >
      <PleaseSelect />
      {timezones.map((timezone) => (
        <option key={timezone.timezone} value={timezone.timezone}>
          {getTimezoneName(timezone)}
        </option>
      ))}
    </Field>
  );
};
